export default function Modal({ show, onClose, title, children, showClose = true }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 rounded-lg w-[420px] max-w-[90%] p-5 shadow-xl">
        <div className="flex items-center justify-between mb-3">
          <h5 className="text-lg font-semibold">{title}</h5>
          {showClose && (
            <button
              className="inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          )}
        </div>

        {children}
      </div>
    </div>
  );
}
